import config from 'lib/config';
import facebookIcon from 'public/static/images/social_media/facebook-icon-white.png';
import twitterIcon from 'public/static/images/social_media/twitter-icon-white.png';
import pinterestIcon from 'public/static/images/social_media/pinterest-icon-white.png';
import instagramIcon from 'public/static/images/social_media/instagram-icon-white.png';
import rssIcon from 'public/static/images/social_media/rss-icon-white.png';
import { useRouter } from 'next/router';
import tapEvent, { FooterAction } from 'lib/Tracking/Footer/TapEvent';
import useEvents from 'lib/hooks/useEvents';

import { screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import { SourcePages } from 'lib/EventSchema';

export default function SocialLinks(): JSX.Element {
  const logger = useEvents();
  const { asPath } = useRouter();
  const { t } = useTranslation();

  function logFooterTapEvent(action: FooterAction): void {
    logger.log(tapEvent({ action, pathName: asPath as SourcePages }));
  }

  return (
    <ul>
      <li>
        <a
          data-testid="facebook"
          href="https://www.facebook.com/AutoList/"
          rel="nofollow noopener noreferrer"
          target="_blank"
          aria-label={t('accessibility.newWindow')}
          className="facebook"
          onClick={(): void => {
            logFooterTapEvent('fb');
          }}
        />
      </li>
      <li>
        <a
          data-testid="twitter"
          href="https://twitter.com/autolistcom"
          rel="nofollow noopener noreferrer"
          target="_blank"
          aria-label={t('accessibility.newWindow')}
          className="twitter"
          onClick={(): void => {
            logFooterTapEvent('twitter');
          }}
        />
      </li>
      <li>
        <a
          data-testid="pinterest"
          href="https://www.pinterest.com/autolistdotcom/"
          rel="nofollow noopener noreferrer"
          target="_blank"
          aria-label={t('accessibility.newWindow')}
          className="pinterest"
          onClick={(): void => {
            logFooterTapEvent('pinterest');
          }}
        />
      </li>
      <li>
        <a
          data-testid="instagram"
          href="https://www.instagram.com/autolist/"
          rel="nofollow noopener noreferrer"
          target="_blank"
          aria-label={t('accessibility.newWindow')}
          className="instagram"
          onClick={(): void => {
            logFooterTapEvent('instagram');
          }}
        />
      </li>
      <li>
        <a
          data-testid="rss"
          href={`${config.host}/articles/rss.xml`}
          rel="nofollow noopener noreferrer"
          target="_blank"
          aria-label={t('accessibility.newWindow')}
          className="rss"
          onClick={(): void => {
            logFooterTapEvent('rss');
          }}
        />
      </li>
      <style jsx>
        {`
          ul {
            margin: 0;
            padding: 0;
            display: inline-flex;
            justify-content: center;
            margin-right: 20px;
          }

          li {
            list-style-type: none;
            text-align: center;
            margin-right: 15px;
          }

          @media (min-width: ${screen.mdMin}) {
            li {
              margin-right: 10px;
            }
          }

          a {
            display: inline-block;
          }

          .facebook {
            height: 17px;
            width: 8px;
            background-repeat: no-repeat;
            background-size: 8px 17px;
            background-image: url(${facebookIcon});
          }

          .twitter {
            height: 17px;
            width: 22px;
            background-repeat: no-repeat;
            background-size: 22px 17px;
            background-image: url(${twitterIcon});
          }

          .pinterest {
            height: 17px;
            width: 11.5px;
            background-repeat: no-repeat;
            background-size: 11.5px 17px;
            background-image: url(${pinterestIcon});
          }

          .instagram {
            height: 17px;
            width: 16.5px;
            background-repeat: no-repeat;
            background-size: 16.5px 17px;
            background-image: url(${instagramIcon});
          }

          .rss {
            height: 17px;
            width: 16.5px;
            background-size: 16.5px 17px;
            background-image: url(${rssIcon});
          }

          @media (min-width: ${screen.smMin}) {
            ul {
              margin-left: 30px;
            }
          }
        `}
      </style>
    </ul>
  );
}
